import {
  EmptyStateProps,
  EmptyStateNoResultIllustration,
} from '@ardoq/status-ui';
import { PrimaryButton } from '@ardoq/button';
import { OnButtonClick } from './types';
import { t, type I18nLocale } from '@ardoq/i18n';

export type NoDataInRequiredPathsArgs = {
  editDataset: OnButtonClick;
  showActionControls?: boolean;
  i18nLocale: I18nLocale;
};

export const noDataInRequiredPaths = ({
  editDataset,
  showActionControls = true,
  i18nLocale,
}: NoDataInRequiredPathsArgs): EmptyStateProps => ({
  media: <EmptyStateNoResultIllustration />,
  title: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataInRequiredPaths.title',
    'No data in the required paths'
  ),
  description: t(
    i18nLocale,
    'tabview:graphViews.emptyStateLayout.noDataInRequiredPaths.description',
    'No components in your dataset match the required paths. Try editing your dataset and adjusting the required paths.'
  ),
  children: !showActionControls ? null : (
    <PrimaryButton onClick={editDataset}>
      {t(
        i18nLocale,
        'tabview:graphViews.emptyStateLayout.noDataInRequiredPaths.editDataset',
        'Edit dataset'
      )}
    </PrimaryButton>
  ),
});
